import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";

import { editCustomerHubspotContactId as editCustomerHubspotContactIdAPI } from "api/customers";
import { customersKeys } from "api/customers/queries";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";

import HubspotContactIdForm, {
  HubspotContactIdFormValues,
} from "./HubspotContactIdForm";

interface EditHubspotContactIdModalProps {
  isOpen: boolean;
  handleClose: () => void;
  hubspotContactId: string;
  customerId: string;
}

const EditHubspotContactIdModal = ({
  isOpen,
  handleClose,
  hubspotContactId,
  customerId,
}: EditHubspotContactIdModalProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const queryClient = useQueryClient();

  const { mutateAsync: editCustomerHubspotContactId, status } = useMutation(
    async (data: { hubspotContactId: string }) => {
      const res = await editCustomerHubspotContactIdAPI(
        customerId,
        data.hubspotContactId,
      );
      await queryClient.invalidateQueries(customersKeys.details(customerId));
      return res.data;
    },
  );

  const handleSubmit = async (values: HubspotContactIdFormValues) => {
    await editCustomerHubspotContactId(values, {
      onSuccess: () => handleClose(),
    });
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="md">
      <ModalHeader
        title="Edit HubSpot Contact ID"
        subtitle="Update the HubSpot contact identifier for this customer."
      />
      <HubspotContactIdForm
        initialValues={{ hubspotContactId }}
        submitStatus={status}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
      />
    </AppDialog>
  );
};

export default EditHubspotContactIdModal;
